import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { WeightContext } from '../Context/WeightContext';

const Weight = () => {
  const context = useContext(WeightContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getWeight();
    };
    getData();
  }, [search]);

  const getWeight = async () => {
    setLoading(true);
    await get(
      `/weight${search}`,
      (res) => {
        context.weights = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/weight/${id}`,
      (res) => {
        success(`وزن "${modalRemoveObject?.weight}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getWeight();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست وزن های'
          createBtnTitle='ایجاد وزن'
          createPath='/weight/create'
        />
        <Datatable
          data={context.weights?.data}
          editUrl='/weight/edit'
          meta={context.weights?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/weight`}
          columns={['وزن']}
          rows={[{ name: 'weight', type: 'string' }]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف وزن "${modalRemoveObject?.weight}" مطمئن هستید ؟`}
      />
    </>
  );
};

export default Weight;
